export default {
    OPEN_MODAL (state, value) {
        state.modal.isOpen = value;
        state.modal.data = {
            actual_duration_hours: null,
            checklist: [],
            attachments: [],
            completed_at: null,
        };
    },
    SET_CHECKLIST_ITEM_VALUE (state, payload) {
        state.modal.data.checklist.forEach(classification => {
            classification.items.forEach(item => {
                if (item.id === payload.itemId) {
                    item.value = payload.value !== item.value ? payload.value : null;
                }
            })
        })
    },
    ADD_FILE (state, data) {
        // A hack for uninitialized field
        if (data.file !== null) {
            state.modal.data.attachments.push(data.file);
        }
    },
    REMOVE_FILE (state, index) {
        state.modal.data.attachments.splice(index, 1);
    },
    TOGGLE_CONFIRMATION_MODAL (state, data) {
        state.confirmation.isOpen = data.isOpen;
        if (data.isOpen) {
            state.confirmation.title = data.title;
            state.confirmation.text = data.text;
            state.confirmation.accept = data.accept;
            state.confirmation.acceptText = data.acceptText;
            state.confirmation.cancel = data.cancel;
            state.confirmation.cancelText = data.cancelText;
        } else {
            state.confirmation.title = '';
            state.confirmation.text = '';
            state.confirmation.accept = null;
            state.confirmation.acceptText = null;
            state.confirmation.cancel = null;
            state.confirmation.cancelText = null;
        }
    },
    TOGGLE_IS_UPLOADING (state, isUploading) {
        state.isUploading = isUploading;
    },
    SET_REVISION (state, value) {
        state.modal.revision = value
    },
    SET_MODAL_DATA (state, data) {
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            state.modal.data[keys[i]] = data[keys[i]];
        }
    },
    SET_CREATION_DATA (state, data) {
        data.classifications.map(classification => {
            classification.items = classification.items.filter(item => item.request_types.filter(type => type.id === state.modal.revision.request_type.id).length > 0)
            return classification;
        })
        state.modal.data.checklist.splice(0, state.modal.data.checklist.length, ...data.classifications);
    },
    SET_MODAL_ERRORS (state, data) {
        state.modal.errors = data;
    },
};
